@use '../@shared/mixins' as *;
@use '../../styles/global' as *;
@use '../tooltip/style.scss' as *;

@layer kol-component {
	.kol-badge {
		/* Visible with forced colors  */
		outline: transparent solid to-rem(1);
		display: inline-flex;
		place-items: center;

		.kol-badge__smart-button {
			.button {
				color: inherit;
			}
		}
	}
}
